import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import type { ElementType } from 'react'
import { InfoIcon } from 'src/v3/core/icons'

type CardSectionHeaderProps = {
  label: string
  className?: string
  component?: ElementType
  tooltipText?: string
}

let CardSectionHeader = ({
  label,
  className,
  component = 'h2',
  tooltipText,
}: CardSectionHeaderProps) => (
  <Box className={`flex items-center gap-2${className ? ` ${className}` : ''}`}>
    <Typography
      component={component}
      className="uppercase"
      sx={{
        fontSize: 12,
        fontWeight: 500,
        letterSpacing: '.08em',
        color: 'text.secondary',
        whiteSpace: 'nowrap',
      }}
    >
      {label}
    </Typography>
    {tooltipText && (
      <Tooltip title={tooltipText}>
        <IconButton
          size="small"
          aria-label={`More information about ${label}`}
          sx={{ p: 0 }}
        >
          <InfoIcon
            fontSize="inherit"
            sx={{ color: 'info.main', fontSize: '1rem' }}
          />
        </IconButton>
      </Tooltip>
    )}
    <Box className="flex-1 h-px" sx={{ bgcolor: 'divider' }} />
  </Box>
)

export default CardSectionHeader
